// extracted by mini-css-extract-plugin
export default {"tx":"_75c09a8cdc","line":"_6e0c2c96a3"};